import { TypeConverter } from "@farris/ide-property-panel";
import { AifLocalePipe } from "../aif-ui-common/pipe/aif-ui-common-locale.pipe";

export class AifCreationBillProcessConverter implements TypeConverter {
    constructor(
        public localePipe: AifLocalePipe
    ) { }

    convertTo(data): string {
        if (data) {
            return data.name || data.code || this.localePipe.transform("set");
        } else {
            return this.localePipe.transform("notSet");
        }
    }
}
